const $ = require('jquery');

$('.booking-form input[name="hotel"]').change(function (e) {
    var synxis_config = $(this).data('synxis');

    if (synxis_config) {
        $('input[name="config"]').val(synxis_config.config);
        $('input[name="theme"]').val(synxis_config.theme);
    }
});

